export default "__VITE_ASSET__DCYXteUA__"